import React, { useState, useEffect } from 'react';
import HeaderTwo from "../components/header/HeaderTwo";
import Breadcrumb from "./Breadcrumb";
import { Link } from 'react-router-dom';
import FooterTwo from "../components/footer/FooterTwo";



function OurService() {
    const breadcrumbs = [
        { label: 'Home', link: '/' },
        { label: 'Sobre Nós' }
    ];
    const [isVideoOpen, setIsVideoOpen] = useState(false);

    // Function to open the video overlay
    const openVideo = (e) => {
        e.preventDefault();
        setIsVideoOpen(true);
    };

    // Function to close the video overlay
    const closeVideo = (e) => {
        e.preventDefault();
        setIsVideoOpen(false);
    };

    // Effect to handle the escape key for closing the video overlay
    useEffect(() => {
        const handleKeyUp = (e) => {
            if (e.keyCode === 27) {
                setIsVideoOpen(false);
            }
        };

        // Add event listener for keyup
        document.addEventListener('keyup', handleKeyUp);

        // Cleanup function to remove event listener on component unmount
        return () => {
            document.removeEventListener('keyup', handleKeyUp);
        };
    }, []);
    return (
        <div className=''>

            <HeaderTwo />
            <Breadcrumb title="Sobre Nós" breadcrumbs={breadcrumbs} />
            {/* rts about us section start */}
<div className="rts-about-area rts-section-gap">
    <div className="container">
        <div className="row g-5 align-items-center">

            {/* Left Images */}
            <div className="col-lg-6">
                <div className="about-image-v-inner">
                    <div className="image-area">
                        <img
                            className="mt--110 img-1"
                            src="assets/images/sobrenos/1.png"
                            alt="GB_Grupo"
                        />
                        <img
                            className="img-over"
                            src="assets/images/sobrenos/2.png"
                            alt="GB_Grupo"
                        />


                    </div>
                </div>
            </div>

            {/* Right Content */}
            <div className="col-lg-6">
                <div className="about-progress-inner">

                   <div className="title-area">
    <span>QUEM SOMOS</span>
    <h2 className="title">
        Soluções financeiras estruturadas para empresas, agronegócio e sustentabilidade
    </h2>
</div>

{/* Text */}
<div className="inner">
    <p className="disc">
        A <strong>GB Partner</strong> é uma empresa especializada em estruturação e intermediação de crédito empresarial e agro, inteligência de mercado, seguros corporativos e soluções em crédito de carbono.
    </p>

    <p className="disc">
        Fundada por profissionais com mais de três décadas de experiência no sistema financeiro, atuamos com foco estratégico para promover a expansão e a segurança dos negócios.
    </p>

    <p className="disc">
        Trabalhamos nacionalmente de forma consultiva, conectando nossos clientes às melhores oportunidades junto a bancos, fundos de investimento, FIDCs e investidores internacionais.
    </p>

                        {/* Progress bars – mantidas, mas renomeadas */}
                        <div className="rts-progress-one-wrapper">

                            <div className="single-progress">
                                <div className="progress-top">
                                    <p className="progress-title">Experiência no Mercado</p>
                                    <span className="persectage">35+</span>
                                </div>
                                <div className="meter cadetblue">
                                    <span data-progress={100} style={{ width: 300 }} />
                                </div>
                            </div>

                            <div className="single-progress">
                                <div className="progress-top">
                                    <p className="progress-title">Soluções Estruturadas</p>
                                    <span className="persectage">100%</span>
                                </div>
                                <div className="meter">
                                    <span data-progress={100} style={{ width: 400 }} />
                                </div>
                            </div>

                        </div>

                        <Link to={'linkwhats'} className="rts-btn btn-primary">
                            Falar com um Especialista
                        </Link>
                    </div>

                </div>
            </div>

        </div>
    </div>
</div>
{/* rts about us section end */}



            {/* rts services area start */}
<div className="rts-service-area rts-section-gapBottom">
    <div className="container-fluid service-main about-service-width-controler">

        <div className="background-service service-three row">
            <div className="row g-5">

                <div className="rts-title-area service-four text-center pt--40">
                    <p className="pre-title">Institucional</p>
                    <h2 className="title">Missão • Visão • Valores</h2>
                </div>

                {/* MISSÃO */}
                <div className="col-xl-4 col-md-6 col-sm-12 col-12 pt--15 mb--80 mb_md--40 mb_sm--30">
                    <div className="service-one-inner-four">
                        <div className="big-thumbnail-area">
                            <Link to={'#'} className="thumbnail">
                                <img
                                    src="assets/images/sobrenos/3/1.png"
                                    alt="GB_missao"
                                />
                            </Link>
                            <div className="content">
                                <img
                                    src="assets/images/sobrenos/3/1.png"
                                    alt="icon"
                                />
                                <h5 className="title">Nossa Missão</h5>
                                <p className="disc">
                                    Conectar empresas, produtores rurais e pessoas às melhores
                                    soluções financeiras do mercado, oferecendo atendimento consultivo,
                                    análise estratégica e segurança em cada operação.
                                </p>
                            </div>
                            <Link href="#" className="over_link" />
                        </div>
                    </div>
                </div>

                {/* VISÃO */}
                <div className="col-xl-4 col-md-6 col-sm-12 col-12 pt--15 mb--80 mb_md--40 mb_sm--30">
                    <div className="service-one-inner-four">
                        <div className="big-thumbnail-area">
                            <Link to={'#'} className="thumbnail">
                                <img
                                    src="assets/images/sobrenos/3/2.png"
                                    alt="GB_visao"
                                />
                            </Link>
                            <div className="content">
                                <img
                                    src="assets/images/sobrenos/3/2.png"
                                    alt="icon"
                                />
                                <h5 className="title">Nossa Visão</h5>
                                <p className="disc">
                                    Consolidar-se como um dos principais grupos nacionais em
                                    intermediação de crédito, inteligência financeira e soluções
                                    estratégicas, sendo reconhecido pela transparência, solidez
                                    e excelência consultiva.
                                </p>
                            </div>
                            <Link href="#" className="over_link" />
                        </div>
                    </div>
                </div>

                {/* VALORES */}
                <div className="col-xl-4 col-md-6 col-sm-12 col-12 pt--15 mb--80">
                    <div className="service-one-inner-four">
                        <div className="big-thumbnail-area">
                            <Link to={'#'} className="thumbnail">
                                <img
                                    src="assets/images/sobrenos/3/3.png"
                                    alt="GB_valores"
                                />
                            </Link>
                            <div className="content">
                                <img
                                    src="assets/images/sobrenos/3/3.png"
                                    alt="icon"
                                />
                                <h5 className="title">Nossos Valores</h5>

                                <p className="disc">
                                    Responsabilidade<br />
                                    Sigilo e confidencialidade<br />
                                    Transparência<br />
                                    Confiança<br />
                                    Segurança e credibilidade<br />
                                    Integridade<br />
                                    Simplicidade e clareza no atendimento
                                </p>
                            </div>
                            <Link href="#" className="over_link" />
                        </div>
                    </div>
                </div>

            </div>
        </div>

        {/* CTA final do template — já adaptado */}
        <div className="row">
            <div className="cta-one-bg col-12">
                <div className="cta-one-inner">
                    <div className="cta-left">
                        <h3 className="title animated fadeIn">
                            Pronto para elevar sua estratégia financeira?
                        </h3>
                    </div>
                    <div className="cta-right">
                        <Link className="rts-btn btn-white" to={'linkwhats'}>
                            Falar com Especialista
                        </Link>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
{/* rts services area End */}


            <FooterTwo />

        </div>
    )
}

export default OurService